import { KibCloseIcon } from "@chewy/kib-icons-react";
import { FC } from "react";
import ReactDOM from "react-dom";
import "./sitewide-banner-modal.scss";

type SitewideBannerModalProps = {
  children: JSX.Element;
  setShow: (value: boolean) => void;
  show: boolean;
};

const SitewideBannerModal: FC<SitewideBannerModalProps> = ({ children, setShow, show }) => {
  if (!show) return null;

  return ReactDOM.createPortal(
    <div className={"cmfe-sitewide-banner-modal"} onClick={() => setShow(false)} data-testid="sitewide-banner-modal">
      <div className={"cmfe-sitewide-banner-modal__content"} onClick={(e) => e.stopPropagation()}>
        {children}
        <button className={"cmfe-sitewide-banner-modal__content__close"} type={"button"} onClick={() => setShow(false)}>
          <KibCloseIcon role="img" aria-label="Close Modal" focusable="false" />
        </button>
      </div>
    </div>,
    document.body,
  );
};

export default SitewideBannerModal;
